import { axiosInstance } from '@/shared/api/axios';
import {
  AiCreditSettingGetResponseType,
  AiCreditSettingPutRequestType,
} from '@/shared/types/api/api.aiCreditSetting';

export const getAiCreditSetting = async ({
  groupId,
}: {
  groupId: number;
}): Promise<AiCreditSettingGetResponseType> => {
  const { data } = await axiosInstance.get<AiCreditSettingGetResponseType>(
    `/group/${groupId}/ai-credit-setting`,
  );
  return data;
};

export const updateAiCreditSetting = async ({
  groupId,
  equityRatio,
  capitalAmount,
}: AiCreditSettingPutRequestType): Promise<AiCreditSettingGetResponseType> => {
  const { data } = await axiosInstance.put<AiCreditSettingGetResponseType>(
    `/group/${groupId}/ai-credit-setting`,
    {
      equityRatio,
      capitalAmount,
    },
  );
  return data;
};
